import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { FavoriteMedicineApi } from '../api/favoritemedicine.api';
import { switchMap, map } from 'rxjs/operators';
import { FavoriteMedicineData, FavoriteMedicine } from '../../../interfaces/masters/favoritemedicine' ;
@Injectable()
export class FavoriteMedicineService extends FavoriteMedicineData {

    constructor(private api: FavoriteMedicineApi) {
      super();
    }
  
  
    list(url: string): Observable<FavoriteMedicine[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<FavoriteMedicine>{
        return this.api.getById(url);
    }
  
    create(url: string, data:FavoriteMedicine): Observable<FavoriteMedicine[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:FavoriteMedicine): Observable<FavoriteMedicine> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  